import React from "react"

const StarIcon = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
      >
        <path
          d="M8.00059 0.557337C8.45394 -0.185779 9.54606 -0.185779 9.99941 0.557338L12.2007 4.16561C12.3635 4.43258 12.6292 4.62298 12.9369 4.69328L17.0959 5.64347C17.9524 5.83916 18.2899 6.86379 17.7135 7.51875L14.915 10.699C14.708 10.9343 14.6065 11.2423 14.6338 11.5528L15.0029 15.7483C15.0789 16.6124 14.1954 17.2456 13.3858 16.9073L9.45501 15.2645C9.16418 15.1429 8.83582 15.1429 8.54499 15.2645L4.61415 16.9073C3.80461 17.2456 2.92106 16.6124 2.99707 15.7483L3.36618 11.5528C3.39349 11.2423 3.29202 10.9343 3.08497 10.699L0.286472 7.51875C-0.289872 6.86379 0.0476136 5.83916 0.904141 5.64347L5.0631 4.69328C5.37081 4.62298 5.63646 4.43258 5.79932 4.16561L8.00059 0.557337Z"
          fill="#FDAD00"
        />
      </svg>
  )
}

export default StarIcon
